import React from 'react'
import { motion } from "framer-motion";
const Contact = () => {
  return (
    <div name="contact" className="w-full h-full bg-gradient-to-b from-gray-200 to-gray-300 dark:bg-gradient-to-b dark:from-gray-700 dark:to-gray-800 p-4 scroll-mt-20">
        <motion.div initial={{ y: 100, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    transition={{ duration: 1.5 }} viewport={{once: true, amount: 0.35}} className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-fit">
            <div className="pb-8">
                <p className="text-4xl font-bold inline border-b-4 border-gray-800 dark:border-gray-200 text-gray-800 dark:text-gray-200">
                    Contact
                </p>
                <p className="py-6 text-gray-800 dark:text-gray-200">Submit the form below to get in touch with me</p>
            </div>
            <div className="flex  justify-center items-center">
                <form action="https://getform.io/f/paqgvyna" method="POST" className="flex flex-col w-full md:w-1/2">
                    <input type="text" name="name" placeholder="Enter your name"
                    className="m-2 p-2 bg-transparent border-2  border-gray-700 dark:border-gray-200 rounded-md placeholder-gray-800 dark:placeholder-gray-200 text-gray-800 dark:text-gray-200 focus:outline-none"/>
                    <input type="text" name="email" placeholder="Enter your email"
                    className="m-2 p-2 bg-transparent border-2 border-gray-700 dark:border-gray-200 rounded-md placeholder-gray-800 dark:placeholder-gray-200 text-gray-800 dark:text-gray-200 focus:outline-none"/>
                    <textarea name="message" rows="10" className="p-2 bg-transparent border-2 border-gray-700 dark:border-gray-200 rounded-md placeholder-gray-800 dark:placeholder-gray-200  text-gray-800 dark:text-gray-200 focus:outline-none">

                    </textarea>
                    <button className="text-gray-800 dark:text-gray-200 bg-orange-400 px-6 py-3 my-8 mx-auto flex justify-center rounded-md hover:scale-105 duration-300">Send Message</button>
                </form>
            </div>
            </motion.div> 

    </div>
  );
};

export default Contact